/** @format */

import {useMemo} from 'react'

export function useMimeTypeOptions() {
  return useMemo(
    () => [
      {label: 'CSV', value: 'text/csv'},
      {label: 'DOC', value: 'application/msword'},
      {
        label: 'DOCX',
        value:
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      },
      {label: 'PDF', value: 'application/pdf'},
      {label: 'TXT', value: 'text/plain'},
      {label: 'XLS', value: 'application/vnd.ms-excel'},
      {
        label: 'XLSX',
        value:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      // images
      {label: 'JPG', value: 'image/jpeg'},
      {label: 'PNG', value: 'image/png'},
      {label: 'GIF', value: 'image/gif'},
      {label: 'SVG', value: 'image/svg+xml'},
      {label: 'WEBP', value: 'image/webp'},
    ],
    [],
  )
}
